<template>
  <div class="mask" @touchmove.prevent>
    <div class="ayden-mask">
      <div class="main_content mask_content">
        <div class="close_btn" @click="cancel"></div>
        <div class="pay_title bold">Century Games</div>
        <div class="payitem" v-loading="loadingis || payis" @touchmove.stop v-touchmove>
          <div id="aydendropin"></div>
        </div>
        <!-- kakao占位 -->
        <p style="height: 30px" v-if="payis && payinfo.gateway === 7501"></p>
        <!-- adyen占位 -->
        <p style="height: 30px" v-if="payis && payinfo.gateway === 7502"></p>
        <p class="pay_tips" v-if="payinfo.gateway === 75">
          <img src="~@img/icon_adyen_tips.png" alt="" />{{ $t('adyen.note') }}
        </p>
        <p class="pay_tips pay_tips2">
          {{ $t('adyen.note2') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdyenCheckout from '@adyen/adyen-web'
import '@adyen/adyen-web/dist/adyen.css'
import { adyenLocaleMap } from '../../tool/constant'
import { getorder, adyen_callback, adyen_payments_details } from '@/api/index.js'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
export default {
  name: 'ayden',
  props: ['payinfo', 'mount'],
  inject: ['newCheckPay'],
  data() {
    return {
      payis: true,
      cg_request_id: '',
      provider_order_id: '',
      payment_methods: [],
      client_key: '',
      loadingis: false,
    }
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      userInfo: (state) => state.user.userInfo,
      loginType: (state) => state.user.loginType,
      isProductionTax: (state) => state.app.isProductionTax,
      userIpCountry: (state) => state.user.userIpCountry,
      postcode: (state) => state.user.postcode,
    }),
  },
  mounted() {
    this.order()
    this.$store.commit('app/SET_IS_NO_SCROLL', true)
  },
  beforeDestroy() {
    this.$store.commit('app/SET_IS_NO_SCROLL', false)
  },
  methods: {
    order() {
      this.$parent.payment_log.report('web_payment_getorder_start')
      const params = {
        ...this.payinfo,
        user_id: this.userInfo.user_id,
        enter_type: this.loginType,
        bonus: this.$store.state.user.isFirst ? 1 : 0,
        taxed: this.isProductionTax,
      }
      const uid = this.$utils.customLocalStorage.getItem(
        `web_shopper_uid_${this.userInfo.user_uid}`
      )
      if (uid) {
        params.web_shopper_uid = uid
      }

      getorder(params)
        .then((res) => {
          //校验黑名单之类的
          if (!this.newCheckPay(res)) {
            return false
          }
          if (res.data.code == 1) {
            this.cg_request_id = res.data.data.cg_request_id + ''
            this.provider_order_id = res.data.data.provider_order_id
            this.$utils.customSessionStorage.setItem(
              'provider_order_id',
              res.data.data.provider_order_id
            )
            this.$parent.updateProviderOrderId(res.data.data.provider_order_id)
            this.client_key = res.data.data.client_key

            //如果paysty 是ayden则去掉kakao和paypay
            if (this.payinfo.gateway == 75) {
              this.payment_methods = {
                ...res.data.data.payment_methods,
                paymentMethods: res.data.data.payment_methods.paymentMethods.filter(
                  (v) => v.type !== 'kakaopay' && v.type !== 'paypay'
                ),
              }
            } else {
              this.payment_methods = {
                paymentMethods: res.data.data.payment_methods.paymentMethods.filter(
                  (v) => v.type === 'kakaopay' || v.type === 'paypay'
                ),
              }
            }

            // 缓存adyen uid
            if (res.data.data.web_shopper_uid) {
              this.$utils.customLocalStorage.setItem(
                `web_shopper_uid_${this.userInfo.user_uid}`,
                res.data.data.web_shopper_uid
              )
            }

            this.$parent.payment_log.set_properties({
              cg_request_id: this.provider_order_id,
            })
            this.$parent.payment_log.report('web_payment_getorder_success')

            this.$parent.payment_log.report('web_payment_sdkinit_start')
            this.ayden()
            this.payis = false

            this.$rum.report(
              'pay_sucess',
              {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo,
              },
              1
            )
          } else {
            this.$parent.failpay('Order failed！')

            this.$parent.payment_log.report('web_payment_getorder_fail', {
              code: 3,
              msg: res.data.msg ? res.data.msg : 'Order failed',
            })

            this.$rum.report(
              'pay_err',
              {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo,
              },
              3
            )
          }
        })
        .catch((error) => {
          console.error(error)
          this.payis = false
          this.$parent.payment_log.report('web_payment_getorder_error', {
            code: 2,
            msg: error,
          })
        })
    },
    cancel() {
      this.$parent.cancelpay()
      this.$parent.payment_log.report('web_payment_userpay_cancel')
    },
    async ayden() {
      console.log(this.payment_methods)
      const configuration = {
        paymentMethodsResponse: this.payment_methods,
        amount: this.isProductionTax ? this.payinfo.taxed_price : this.mount,
        clientKey: this.client_key,
        locale: adyenLocaleMap[this.$i18n.locale],
        environment: process.env.VUE_APP_STY, //生产环境需要更改为"live"
        onSubmit: (state, dropin) => {
          this.loadingis = true
          var obj = {
            state_data: JSON.stringify(state.data),
            provider_order_id: this.provider_order_id,
            user_id: this.userInfo.user_id,
          }

          const taData = {
            iap_product_id: this.payinfo.product_id,
            payment_type: this.payinfo.gateway == 75 ? 'adyen' : 'kakao', //添加kakao
            operator_type: 3,
            amount:
              this.isProductionTax && this.payinfo.taxed_price
                ? this.payinfo.taxed_price
                : this.payinfo.amount,
            currency: this.payinfo.currency,
            server_id: this.payinfo.user_extra_value,
            tid: this.provider_order_id,
            use_type: 1,
            ...getCallPaymentLimitTrackingProps(this.$parent.pack),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameId === '20195') {
            taData.iap_name = this.payinfo.data_name || ''
            taData.pkg_id = this.payinfo.pack_id || ''
            taData.reward = this.payinfo.reward || ''
          }
          this.$ta.track('call_payment', taData)

          this.$parent.payment_log.report('web_payment_userpay_success')
          this.$parent.payment_log.report('web_payment_verification_start')

          // console.log(state)
          // console.log(obj)

          adyen_callback(obj)
            .then((response) => {
              if (response.data.code == 1) {
                //Drop-in会自动根据这里拿到的action来处理/payments接口的响应
                if (response.data.data.action) {
                  dropin.handleAction(response.data.data.action)
                } else {
                  this.$parent.successpay(response.data.data)

                  this.$parent.payment_log.set_properties({
                    transaction_id: response.data.data.transaction_id
                      ? response.data.data.transaction_id
                      : '',
                  })
                  this.$parent.payment_log.report('web_payment_check_success')
                }
                this.loadingis = false
                this.$rum.report(
                  'pay_sucess',
                  {
                    paystyle: 'ayden',
                    type: 'onSubmit',
                    response: response,
                    prams: obj,
                  },
                  1
                )
              } else {
                let langKey = ''
                let uuid = ''
                if (response.data.code == 101031025) {
                  langKey = 'pay.limitPackBuyFail'
                  uuid = this.provider_order_id
                } else {
                  langKey = response.data.fail_code
                  uuid = response.data.uuid
                }
                this.$parent.failpay({
                  ...response.data,
                  data: {
                    ...(response.data.data || {}),
                    fail_code: langKey,
                    uuid: uuid,
                  },
                })
                this.loadingis = false

                this.$parent.payment_log.report('web_payment_check_fail', {
                  code: 3,
                  msg: response.data.msg ? response.data.msg : 'adyen_callback failed',
                })

                this.$rum.report(
                  'pay_err',
                  {
                    paystyle: 'ayden',
                    type: 'onSubmit',
                    response: response,
                    prams: obj,
                  },
                  3
                )
              }
            })
            .catch((error) => {
              console.log(error)
              this.$parent.failpay(error)
              this.loadingis = false

              this.$parent.payment_log.report('web_payment_check_error', {
                code: 2,
                msg: error,
              })

              this.$rum.errorReport(error)
              throw Error(error)
            })
        },
        onAdditionalDetails: (state, dropin) => {
          var obj = {
            details: JSON.stringify(state.data),
            provider_order_id: this.provider_order_id,
          }

          this.$parent.payment_log.report('web_payment_checkAgain_start')

          this.payis = true

          adyen_payments_details(obj)
            .then((response) => {
              if (response.data.code == 1) {
                this.$parent.successpay(response.data.data)

                this.$parent.payment_log.set_properties({
                  transaction_id: response.data.data.transaction_id
                    ? response.data.data.transaction_id
                    : '',
                })
                this.$parent.payment_log.report('web_payment_checkAgain_success')

                this.$rum.report(
                  'pay_sucess',
                  {
                    paystyle: 'ayden',
                    type: 'onAdditionalDetails',
                    response: response,
                    prams: obj,
                  },
                  1
                )
              } else {
                let langKey = ''
                let uuid = ''
                if (response.data.code == 101031025) {
                  langKey = 'pay.limitPackBuyFail'
                  uuid = this.provider_order_id
                } else {
                  langKey = response.data.fail_code
                  uuid = response.data.uuid
                }
                this.$parent.failpay({
                  ...response.data,
                  data: {
                    ...(response.data.data || {}),
                    fail_code: langKey,
                    uuid: uuid,
                  },
                })

                this.$parent.payment_log.report('web_payment_checkAgain_fail', {
                  code: 3,
                  msg: response.data.msg ? response.data.msg : 'adyen_payments_details failed',
                })

                this.$rum.report(
                  'pay_err',
                  {
                    paystyle: 'ayden',
                    type: 'onAdditionalDetails',
                    response: response,
                    prams: obj,
                  },
                  3
                )
              }
              this.loadingis = false
              this.payis = false
            })
            .catch((error) => {
              this.$parent.failpay(error)
              this.loadingis = false
              this.payis = false
              this.$parent.payment_log.report('web_payment_checkAgain_error', {
                code: 2,
                msg: error,
              })
              this.$rum.errorReport(error)
              throw Error(error)
            })
        },
        onError: (error) => {
          this.$rum.report(
            'pay_err',
            {
              paystyle: 'ayden',
              type: 'aydenerror',
              response: error,
              prams: {
                provider_order_id: this.provider_order_id,
              },
            },
            3
          )
          console.error('Failed to load Adyen Checkout SDK', error)
          console.log(error)
        },
        paymentMethodsConfiguration: {
          card: {
            //决定是否需要隐藏持卡人姓名输入框
            hasHolderName: true,
            //决定持卡人姓名输入框是否必填
            holderNameRequired: true,
            //决定是否需要隐藏绑卡勾选框
            enableStoreDetails: true,
            //若您在使用绑卡交易并且不需要买家输入CVC时(recurringProcessingModel=Subscription或UnscheduledCardOnFile)，您可将这里改成true来隐藏CVC输入栏，详情参考tokenization绑卡交易具体对接文档)
            hideCVC: false,
            //定义了前段展示的文案
            name: 'Credit or debit card',
            billingAddressRequired: ['US', 'CA'].includes(this.userIpCountry),
            billingAddressMode: 'partial',
            data: {
              billingAddress: {
                country: this.userIpCountry,
                postalCode: this.postcode,
              },
            },
          },
        },
      }
      //console.log(configuration)
      const checkout = await AdyenCheckout(configuration)
      const dropin = checkout.create('dropin', {
        onReady: () => {
          console.log('Adyen Checkout SDK is onReady')
          this.$parent.payment_log.report('web_payment_sdkinit_success')
          this.$parent.payment_log.report('web_payment_userpay_start')
        },
        onError: (error) => {
          this.$parent.payment_log.report('web_payment_sdkinit_fail', {
            code: 2,
            msg: error,
          })
          console.error('Failed to load Adyen Checkout SDK', error)
          console.log(error)
        },
      })
      dropin.mount('#aydendropin')
      console.log(dropin)
    },
  },
}
</script>

<style lang="less" scoped>
.ayden-mask {
  .main_content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: auto;
    background: #fff;
    border-radius: 16px;
    padding: 0px 12px 12px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    /* 或 scroll */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    scrollbar-width: none;

    /* Firefox */
    .close_btn {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 12px;
      right: 12px;
      cursor: pointer;
      .bg-image('close');
    }

    .pay_title {
      font-size: 19px;
      color: #000000;
      line-height: 32px;
      margin: 8px auto;
      text-align: center;
      font-weight: 700;
    }
    .payitem {
      min-height: 200px;
      max-height: 500px;
      overflow-y: auto;
      position: relative;
      font-size: 16px;
    }
  }
  .pay_tips {
    font-size: 12px;
    color: #666666;
    margin-top: 10px;
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 4px;
      vertical-align: middle;
    }
    &.pay_tips2 {
      color: #4b5560;
      margin-top: 5px;
    }
  }
  ::v-deep(.adyen-checkout__helper-text),
  ::v-deep(.adyen-checkout__label__text) {
    line-height: 1.1;
  }
}

@media (max-width: 1024px) {
  .ayden-mask {
    .main_content {
      max-height: calc(100% - 50px);
      width: 100%;
      border-radius: 16px 16px 0 0;
      bottom: 0;
      top: unset;
      left: 0;
      transform: none;
      overflow: auto;
    }
  }
}
</style>
